
export const sFechaPublicacion = '2026-04-01T19:25:55.0184567-06:00';
export const sVersion = 'vf1.1.604011925';
            